<script setup lang="ts">
    import { CompanyGroup } from '@/types';
    import { useForm } from '@inertiajs/vue3';
    import CompanyGroupForm from '@/components/company-groups/CompanyGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const props = defineProps<{
        companyGroup: CompanyGroup;
    }>();

    const form = useForm({
        name: props.companyGroup.name,
        companyIds: props.companyGroup.companies.map((company) => company.id.toString()),
    });
</script>

<template>
    <DialogForm
        type="update"
        :form="form"
        :route="route('v2.company-groups.update', props.companyGroup.id)"
        :query-key="[QueryKey.COMPANY_GROUPS]"
        title="company-groups.company_groups_edit"
        success-message="company-groups.updated"
        error-message="company-groups.update.error"
    >
        <CompanyGroupForm :form="form" />
    </DialogForm>
</template>
